module.exports = __webpack_public_path__ + "img/social02.bfddff3f.svg";